<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      confirm-text="创建货件"
      notFooterPadding
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>预览货件</span>
    </template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          inline
          >
        <gj-table
          :loading="loading"
          :columns="columns"
          :data="form.items"
          :offsetHeight="55"
          :index="false"
          :show-overflow="false"
          expand>
          <template v-slot:header:quantityShipped>
            <span class="gj-mr40">货件申报量</span>
          </template>
          <template v-slot:name="{index}">
            <el-form-item
                :prop="`items.${index}.name`"
                :rules="[
                   { required: true, message: '请输入货件名', trigger: ['blur', 'change'] },
                 ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].name"
                  width="250px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:quantityShipped="{row}">
            <span class="gj-mr40">{{row.quantityShipped}}</span>
          </template>
          <template v-slot:expand="{expandRow, expandIndex}">
            <gj-table
                :data="expandRow.items"
                :columns="expandColumns"
                :adapt-height="false"
                :index="false">
              <template v-slot:header:quantityShipped>
                <span class="gj-mr20">申报量</span>
              </template>
              <template v-slot:quantityShipped="{ row, index }">
                <el-form-item
                    :prop="`items.${expandIndex}.items.${index}.quantityShipped`"
                    :rules="[
                      { required: true, message: '请输入数量', trigger: ['blur', 'change'] },
                      $gjReRule(RE.pt, '请输入大于0的整数')
                    ]"
                    class="gj-table-item">
                  <gj-input
                      v-model="form.items[expandIndex].items[index].quantityShipped"
                      width="120px">
                  </gj-input>
                </el-form-item>
              </template>
            </gj-table>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, formValidatorMixin, modalMixIn, responseMixin} from "@/minxins";
  import {createFbaShipment, previewFbaShipment} from "@/api/logistics";

  export default {
    name: "app-preview-fba-shipment-modal",
    mixins: [modalMixIn, formRuleMixin, formValidatorMixin, responseMixin],
    props: {
      previewShipmentParams: {
        required: true
      }
    },
    data() {
      return {
        columns: [
          {id: 'shipmentId', header: 'ShipmentID', field: 'shipmentId', minWidth: '100px'},
          {id: 'name', header: '货件名称', field: 'slot:name', width: '300px', required: true},
          {id: 'mskuSpecies', header: '产品种类', field: 'mskuSpecies', width: '150px', align: 'right'},
          {id: 'quantityShipped', header: 'slot:quantityShipped', field: 'slot:quantityShipped', width: '180px', align: 'right'},
          {id: 'centerId', header: '亚马逊仓代码', field: 'centerId', width: '100px'},
        ],
        expandColumns: [
          {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '50px'},
          {id: 'skuName', header: '产品名称', field: 'skuName', minWidth: '200px'},
          {id: 'msku', header: 'MSKU', field: 'msku', width: '150px'},
          {id: 'fnsku', header: 'FNSKU', field: 'fnsku', width: '150px'},
          {id: 'asin', header: 'ASIN', field: 'asin', width: '150px'},
          {id: 'quantityShipped', header: 'slot:quantityShipped', field: 'slot:quantityShipped', width: '140px', required: false},
        ],
        form: {
          items: [],
        },
        loading: false,
        confirmLoading:false,
      }
    },
    created() {
      this.loading = true;
      previewFbaShipment(this.previewShipmentParams)
        .then((data) => {
          this.form.items = data;
        })
        .complete(() => this.loading = false);
    },
    methods: {
      confirm() {
        if (this.form.items.length === 0) {
          this.$gjMessage.error('商品不能为空');
          return;
        }
        if (this.formValidate()) {
          this.confirmLoading = true;
          const params = {
            ...this.previewShipmentParams,
            items: null, // 清除 previewShipmentParams 中多余数据
            shipmentPlanDTOList: this.form.items
          };
          createFbaShipment(params)
            .then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('创建成功');
                this.$emit('created', res.data);
                this.$gjDestroy();
              });
            })
            .complete(() => {
              this.confirmLoading = false;
            });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
 /deep/ .vxe-table .vxe-body--expanded-cell{
   padding: 12px 16px;
 }
 /deep/ .gj-table--default td.vxe-body--column{
   height: 56px !important;
 }
</style>

